import React from 'react'
import PropTypes from 'prop-types'
import graphql from "graphql"

import { kebabCase } from 'lodash'
import Helmet from 'react-helmet'
import Link, { navigateTo } from 'gatsby-link'
import Img from "gatsby-image"
import VimeoBackgroundCover from '../components/VimeoBackgroundCover.js'
import ScrollAnimation from 'react-animate-on-scroll'
import { isMobile } from 'react-device-detect'
import { scroller } from 'react-scroll';
import LazyLoad from 'react-lazyload';
import { parseVimeoUrl } from '../utils/vimeo';

class ProjectList extends React.Component {

  static propTypes = {
    projects: PropTypes.array,
    filter: PropTypes.object,
  }

  state = {
    activePreviews: [],
    canAutoplay: true,
    videosLoaded: [],
  }

  _onEnter = (index) => {
    if (this.state.activePreviews.indexOf(index) === -1) {
      this.setState({
        activePreviews: [...this.state.activePreviews, index]
      });
    }
  }

  _onLeave = (index) => {
    this.setState({ activePreviews: this.state.activePreviews.filter(i => i !== index) });
  }

  _onVideoLoad = (event) => {
    this.setState({
      videosLoaded: [...this.state.videosLoaded, event.id.toString()]
    });
  }

  render() {
    const { projects, filter } = this.props;
    const { canAutoplay, videosLoaded } = this.state;

    return projects
    .filter(
      ({ node: { tags, frontmatter: { featured } } }) =>
      (filter && filter.tag && tags.indexOf(filter.tag) !== -1) || (!filter && featured)
    )
    .map(({ node: { fields, tags, frontmatter: { title, videoUrl, image } } }, index) => (
      <ScrollAnimation
        key={fields.slug}
        animateIn="fadeIn"
        animateOut="fadeOut"
      >
        <div
          onClick={() => navigateTo({
            pathname: fields.slug,
            state: { transition: 'fade' }
          })}
          className={
            "b-project-item m-text-white" +
            (index % 3 === 1 ? ' m-full' : '') +
            (index % 3 === 0 ? ' m-left' : '') +
            (index % 3 === 2 ? ' m-right' : '')
          }
        >
          <div className="b-video-container m-cover-background is-overlay" style={{ zIndex: -1, backgroundImage: (fields.imageFile && videosLoaded.indexOf(parseVimeoUrl(videoUrl).id) === -1 ? `url("${fields.imageFile.childImageSharp.resolutions.src}")` : '') }}>
            <LazyLoad height={0} debounce={0} throttle={100}>
              { canAutoplay ? <VimeoBackgroundCover currentTime={30} url={videoUrl} onLoaded={this._onVideoLoad} /> : null }
            </LazyLoad>
          </div>
          <div className="columns is-gapless">
            <div className="column">
              <div name={kebabCase(title)} className="m-white-borders">
                <Link className="is-hidden-mobile" to={{
                  pathname: fields.slug,
                  state: { transition: 'fade' }
                }}>
                  <h1 className="home-title is-size-3 is-size-5-touch has-text-weight-bold is-bold-light">
                    {title}
                  </h1>
                </Link>
                {tags && tags.length ? (
                  <ul className="taglist is-capitalized is-size-6-touch">
                    {tags.map(tag => (
                      <li key={tag + `tag`}>
                        {tag}
                      </li>
                    ))}
                  </ul>
                ) : null}
              </div>
            </div>
          </div>
        </div>
        <div className="content is-hidden-tablet" style={{ marginBottom: '2rem' }}>
          <Link to={{
            pathname: fields.slug,
            state: { transition: 'fade' }
          }}>
            <h1 className="home-title is-size-3 is-size-5-touch has-text-weight-bold is-bold-light">
              {title}
            </h1>
          </Link>
        </div>
      </ScrollAnimation>

    ))
  }

}

// The filter dropdown used to be fed by `group(field: frontmatter___tags)`, but
// that enum vanishes from Gatsby's schema whenever no project carries a tag.
// Counting the tags here keeps the same `{ fieldValue, totalCount }` shape without
// depending on the inferred schema.
const tagGroups = projects => {
  const totals = {};
  projects.forEach(({ node: { tags } }) => {
    (tags || []).forEach(tag => {
      totals[tag] = (totals[tag] || 0) + 1;
    });
  });

  return Object.keys(totals).sort().map(fieldValue => ({
    fieldValue,
    totalCount: totals[fieldValue],
  }));
};

let LAST_FILTER = false;

export default class ProjectsPage extends React.Component {

  state = {
    filter: false,
    mounted: false,
    isActive: false,
  }

  componentDidMount() {
    this.setState({ mounted: true, filter: LAST_FILTER });
  }

  render() {
    const {
      data: { projects: { edges: projects }, site: { siteMetadata: { title } } },
    } = this.props;
    const { mounted, filter, isActive } = this.state;
    const group = tagGroups(projects);

    return (
      <section className="section m-background-black">
        <div className="container is-fluid" style={{ zIndex: 1 }}>
          <div className="columns" style={{ marginBottom: '2rem', position: 'relative', zIndex: 1 }}>
            <div className="column is-8" style={{  }}>
              <h1 className="home-title is-size-3 is-size-5-touch animated fadeIn">
                Selection of projects
              </h1>
            </div>
            <div className="column is-4">
              <div
                className={"dropdown" + (!isMobile && mounted ? ' is-pulled-right is-right has-text-right is-hoverable' : '') + (mounted && isActive ? ' is-active' : '')}
                style={{ marginTop: '-0.5rem' }}
              >
                <div className="dropdown-trigger">
                  <button className="m-filter home-title is-size-3 is-size-5-touch m-text-white is-uppercase has-text-weight-bold" aria-haspopup="true"
                    onClick={() => {
                      if (isMobile) {
                        this.setState({ isActive: !this.state.isActive });
                      }
                    }}
                  >
                    <span>{filter ? filter.tag : 'Filter'}</span>
                  </button>
                </div>
                <div className="dropdown-menu" role="menu">
                  <div className="dropdown-content m-text-white home-title">
                    {group.sort((a, b) => a.fieldValue.length > b.fieldValue.length).map(tag => (
                      <a
                        href="#"
                        key={tag.fieldValue}
                        onClick={(event) => {
                          event.preventDefault();
                          if (filter && filter.tag === tag.fieldValue) {
                            this.setState({ filter: false, isActive: false });
                            LAST_FILTER = false;
                          } else {
                            this.setState({
                              isActive: false,
                              filter: {
                                tag: tag.fieldValue
                              }
                            });
                            LAST_FILTER = { tag: tag.fieldValue };
                          }
                          scroller.scrollTo('/projects', {
                            offset: 0,
                            smooth: false,
                          });
                        }}
                        className={`dropdown-item is-size-3 is-size-5-touch ${filter && filter.tag === tag.fieldValue ? 'is-active' : ''}`}
                      >
                        {tag.fieldValue}
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ProjectList projects={projects} {...( filter ? { filter: filter } : {})} />
        </div>
      </section>
    )
  }
}

export const fragment = graphql`
  fragment projectsList on RootQueryType {
    site {
      siteMetadata {
        title
      }
    }
    projects: allMarkdownRemark(
      limit: 100
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { templateKey: { eq: "project-post" } } }
    ) {
      totalCount
      edges {
        node {
          fields {
            slug
            imageFile {
              childImageSharp {
                resolutions(width: 800) {
                  ...GatsbyImageSharpResolutions
                }
              }
            }
          }
          tags
          frontmatter {
            title
            image
            videoUrl
            featured
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/projects-page.js